import Chat from "../../images/Chat.png";
import Appointment from "../../images/Apoointment.png";
import Test from "../../images/Test.png";
import PayBill from "../../images/PayBill.png";
import { useNavigate } from "react-router-dom";

import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import useStyles from "../../css/styles";
//FB 7405 - Begin
import { useEffect, useState } from "react";
import { GetAdminSettingValue } from "../../api";
//FB 7405 - End

// Update log
// FB  6192   02/06/2023  DK   Added Home page
// FB  6918   01/06/2023  DK   Admin login is not visible on mobile version
// FB  7405   09/21/2023  SK   Orady - Portal changes
// FB  7469   09/27/2023  SK   Patient Portal - Replace Doctor Direct with License Name , Update logo in Payment Receipt , Change in texts in Home Page
// FB  7874   12/07/2023  DK   Admin should be able to access patient pages
// FB  8716   05/13/2024  GA   The EMR Portal Setting enable_portal_dashboard_options Should Also Govern the Options Displayed on the Login Page

export default function Home() {
  const navigate = useNavigate();
  const classes = useStyles();
  //FB 7405 - Begin
  const [HeaderText, setHeaderText] = useState("");
  //FB 8716 Begin
  const [enableAppointments, setEnableAppointments] = useState(false);
  const [enableMessages, setEnableMessages] = useState(false);
  const [enableTestResults, setEnableTestResults] = useState(false);
  const [enableMyRecords, setEnableMyRecords] = useState(false);
  const [enablebilling, setEnableBilling] = useState(false);
  const [enableClinicalDocs, setEnableClinicalDocs] = useState(false);
  
  async function LoadHeaderText() {
    let setting = await GetAdminSettingValue("LicenseeName");
    setHeaderText(setting);
    sessionStorage.setItem("LicenseeName", setting);//FB 7469
   
    let options = sessionStorage.getItem("enable_portal_dashboard_options");

    if (options == undefined || options == null) {
      let value = await GetAdminSettingValue("enable_portal_dashboard_options");
      options = value;
      sessionStorage.setItem("enable_portal_dashboard_options", value);
    }
    
    if (options) {
      const values = options.split(',').map(Number); 
      setEnableAppointments(values.includes(1));
      setEnableMessages(values.includes(2));
      setEnableTestResults(values.includes(3));
      setEnableMyRecords(values.includes(4));
      setEnableBilling(values.includes(5));
      setEnableClinicalDocs(values.includes(6));
    }
  }
  //FB 8716 End

  useEffect(() => {
    LoadHeaderText();
  }, []);
  //FB 7405 - End


  return (
    <>
      {window.innerWidth < 768 ? (
        <Grid
          container
          spacing={2}
          direction="column"
          style={{ backgroundColor: "#F5F5F5", padding: 16 }}
        >
          <Grid item xs={11}>
            <Typography variant="h5" style={{ fontWeight: "bold" }}>
              Your Healthcare information when you need it
            </Typography>
          </Grid>
          <Grid item xs={11}>
            <Card className={classes.Card_Home_mobile}>
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold" }}
                  gutterBottom
                >
                  Create an account
                </Typography>
                <Typography variant="h6" component="div">
                  Don't have an account?
                </Typography>
                <br />
                <Typography>
                  Create an account in a few easy steps to access healthcare
                  portal.
                </Typography>
              </CardContent>
              <CardActions className={classes.CardAction_Home_mobile}>
                <Button
                  className={classes.Button_NoCapt}
                  onClick={() => navigate("/user/signup")}
                >
                  Create an account
                </Button>
              </CardActions>
            </Card>
          </Grid>
          <Grid item xs={11}>
            <Card className={classes.Card_Home_mobile}>
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold" }}
                  gutterBottom
                >
                  View my account
                </Typography>
                <Typography variant="h6" component="div">
                  Already have an account?
                </Typography>
                <br />
                <Typography>
                  Enter your sign in information for access to your healthcare
                  portal.
                </Typography>
              </CardContent>
              <CardActions className={classes.CardAction_Home_mobile}>
                <Button
                  className={classes.Button_NoCapt}
                  onClick={() => navigate("/user/login")}
                >
                  View my account
                </Button>
              </CardActions>
            </Card>
          </Grid>
          {/* FB 6918 */}
          <Grid item xs={11}>
            {/* FB 7874 - Removed Admin login feature from landing page */}
          </Grid>
        </Grid>
      ) : (
        <div className="card bg-light mb-3" style={stylestart.container}>
          {/* <h3 style={stylestitle.container}>
          In Touch Pediatrics and Lactation patient portal by{" "}
          <span style={font.container}>Doctor Direct</span>
        </h3> */}
          <label style={stylestitle.container}>
            {/* FB 7405 - Begin */}
            {HeaderText}{" "}{"Patient Portal"}{" "}
            <span style={font.container}>by Doctor Direct</span>
            {/* FB 7405 - End */}
          </label>
          <div className="card  bg-light mb-3" style={stylesbegin.container}>
            <div
              style={{
                padding: "32px 80px",
                backgroundColor: "#F5F5F5",
              }}
            >
              <div
                style={{
                  backgroundColor: "#F5F5F5",
                  display: "flex",
                  flexDirection: "row",
                  gap: "64px",
                }}
              >
                <div
                  className="card"
                  style={{
                    maxWidth: "560px",
                    border: "1px grey",
                    backgroundColor: "white",
                    padding: "32px 40px",
                  }}
                >
                  <div className="card-body">
                    <span
                      className="card-title"
                      style={{
                        fontFamily: "Inter",
                        fontSize: "24px",
                        fontWeight: 700,
                        lineHeight: "32px",
                        letterSpacing: "0em",
                        paddingTop: "46.5px",
                      }}
                    >
                      Create an account
                    </span>

                    <label
                      className="card-text"
                      style={{
                        fontFamily: "Inter",
                        fontSize: "24px",
                        fontWeight: 400,
                        lineHeight: "32px",
                        letterSpacing: "0em",
                        textAlign: "left",
                        paddingTop: "16px",
                        paddingBottom: "16px",
                      }}
                    >
                      Don't have an account?
                    </label>
                    <label
                      className="card-text"
                      style={{
                        fontFamily: "Inter",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "24px",
                        letterSpacing: "0em",
                        textAlign: "left",
                        paddingBottom: "16px",
                      }}
                    >
                      Create an account in a few easy steps to access healthcare
                      portal.
                    </label>

                    {/* <Link to="/details" className="btn" style={button.container}>Create an account</Link> */}
                    <button
                      // href="/user/signup"
                      className="btn"
                      style={button.container}
                      onClick={() => navigate("/user/signup")}
                    >
                      Create an Account
                    </button>
                    {/* </div> */}
                  </div>
                </div>
                <div
                  className="card"
                  style={{
                    maxWidth: "560px",
                    border: "1px grey",
                    backgroundColor: "white",
                    padding: "32px 40px",
                  }}
                >
                  <div className="card-body">
                    <span
                      className="card-title"
                      style={{
                        fontFamily: "Inter",
                        fontSize: "24px",
                        fontWeight: 700,
                        lineHeight: "32px",
                        letterSpacing: "0em",
                        paddingTop: "46.5px",
                      }}
                    >
                      View my Account
                    </span>

                    <label
                      className="card-text"
                      style={{
                        fontFamily: "Inter",
                        fontSize: "24px",
                        fontWeight: 400,
                        lineHeight: "32px",
                        letterSpacing: "0em",
                        textAlign: "left",
                        paddingTop: "16px",
                        paddingBottom: "16px",
                      }}
                    >
                      Already have an account?
                    </label>
                    <label
                      className="card-text"
                      style={{
                        fontFamily: "Inter",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "24px",
                        letterSpacing: "0em",
                        textAlign: "left",
                        paddingBottom: "16px",
                      }}
                    >
                      Enter your sign in information for access to your
                      healthcare portal.
                    </label>

                    {/* <Link to="/details" className="btn" style={button.container}>Create an account</Link> */}
                    <button
                      // href="/user/signup"
                      className="btn"
                      style={button.container}
                      onClick={() => navigate("/user/login")}
                    >
                      View my account
                    </button>
                    {/* </div> */}
                  </div>
                </div>
                {/* FB 7874 - Removed Admin login feature from landing page */}
              </div>
            </div>
            {/* FB 8716 Begin-Modified the below div structure */}
            <div
              className="row"
              style={{
                backgroundColor: "#F5F5F5",
                height: "300px",
                paddingLeft: "35px",
                marginBottom:"100px"
              }}
            >
              <div className="col-sm-6" style={{display: enableMessages ? "block" : "none"}}> {/* FB 8716 */} 
                <div className="card bg-light mb-3" style={stylesone.container}>
                  <div
                    className="card-img-top d-flex align-items-center "
                    style={{ backgroundColor: "#F5F5F5" }}
                  >
                    <div>
                      <img
                        className="dplogo"
                        src={Chat}
                        alt=""
                        height="45px"
                      ></img>
                    </div>
                    &nbsp;
                    <div
                      // className="col md-6"
                      style={{ backgroundColor: "#F5F5F5" }}
                    >
                      <h5 className="col p-2 m-0">Message your physician</h5>
                      {/* <label>Message your physician</label> */}
                      <div className="col">
                        <p className="col px-2 m-0">
                          Ask your doctor a question without having to pick up
                          the phone
                        </p>
                        {/* <label>
                        Ask your doctor a question without having to pick up the
                        phone
                      </label> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-6" style={{display: enableAppointments ? "block" : "none" }}>  {/* FB 8716 */} 
                <div className="card bg-light mb-3" style={stylesone.container}>
                  <div
                    className="card-img-top d-flex align-items-center "
                    style={{ backgroundColor: "#F5F5F5" }}
                  >
                    <div>
                      <img
                        className="dplogo"
                        src={Appointment}
                        alt=""
                        height="45px"
                      ></img>
                    </div>
                    &nbsp;
                    <div className="col" style={{ backgroundColor: "#F5F5F5" }}>
                      <h5 className="col p-2 m-0">Book an appointment</h5>
                      {/* <label>Book an appointment</label> */}
                      <div className="col">
                        <p className="col px-2 m-0">
                          Book, cancel, and manage appointments through your
                          portal
                        </p>
                        {/* <label>
                        Book, cancel, and manage appointments through your
                        portal
                      </label> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            
              <div className="col-sm-6" style={{display: enableTestResults ? "block" : "none"}}>  {/* FB 8716 */} 
                <div className="card bg-light mb-3" style={styles.container}>
                  <div
                    className="card-img-top d-flex align-items-center "
                    style={{ backgroundColor: "#F5F5F5" }}
                  >
                    <div>
                      <img
                        className="dplogo"
                        src={Test}
                        alt=""
                        height="45px"
                      ></img>
                    </div>
                    &nbsp;
                    <div className="col" style={{ backgroundColor: "#F5F5F5" }}>
                      <h5 className="col p-2 m-0">View your test results</h5>
                      <div className="col">
                        <p className="col p-2 m-0">
                          Access test results without having to call your doctor
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-6" style={{display: enablebilling ? "block" : "none" }}>  {/* FB 8716 */} 
                <div className="card bg-light mb-3" style={styles.container}>
                  <div
                    className="card-img-top d-flex align-items-center "
                    style={{ backgroundColor: "#F5F5F5" }}
                  >
                    <div>
                      <img
                        className="dplogo"
                        src={PayBill}
                        alt=""
                        height="45px"
                      ></img>
                    </div>
                    &nbsp;
                    <div className="col" style={{ backgroundColor: "#F5F5F5" }}>
                      <h5 className="col p-2 m-0">Pay your bills</h5>
                      <div className="col">
                        <p className="col p-2 m-0">
                          View invoices and easily pay your bill{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* FB 8716 End */}
          </div>
        </div>
      )}
    </>
  );
}

const stylesbegin = {
  container: {
    border: "1px grey",
    padding: "left",
    backgroundColor: "#F5F5F5",
  },
} as const;
const styles = {
  container: {
    width: 700,
    border: "1px grey",
    top: 50,//FB 8716
    backgroundColor: "#F5F5F5",
    left: 50,
  },
} as const;
const stylesone = {
  container: {
    width: 700,
    border: "1px grey",
    top: 50,
    backgroundColor: "#F5F5F5",
    left: 50,
  },
} as const;
const stylestitle = {
  container: {
    textAlign: "left",
    color: "#083A4D",
    backgroundColor: "#F5F5F5",
    // fontWeight: "bold",
    // fontFamily: "Inter",
    fontWeight: "700",
    fontSize: "32px",
    lineHeight: "40px",
    paddingLeft: "80px",
    paddingTop: "10px",
  },
} as const;
const footer = {
  container: {
    backgroundColor: "#13607C",
  },
};
const stylestart = {
  container: {
    border: "1px grey",
    backgroundColor: "#F5F5F5",
    maxHeight: "780px",
  },
};
const button = {
  container: {
    backgroundColor: "#13607C",
    color: "white",
  },
};
const font = {
  container: {
    fontWeight: "lighter",
  },
};
